// extracted by mini-css-extract-plugin
module.exports = {"tabsHeader":"OurResourcesTemplate-module--tabs-header--1N2rh","tabList":"OurResourcesTemplate-module--tab-list--3pBQa"};